import React, { useState } from "react";
import "./ApplyNow.css";

const ANF = () => {




  const [language, setLanguage] = useState("en");

  const translations = {
    en: {
      heading: "Apply For A Loan",
      submit: "Submit Application",
      placeholders: {
        first_name: "First Name*",
        last_name: "Last Name*",
        email: "Email*",
        phone: "Mobile Number*",
        pincode: "PIN Code*",
        income: "Monthly Net Income (₹)*",
        loan_amount: "Required Loan Amount (₹)*",
        questions: "Additional Questions (Optional)"
      },
      selectOptions: {
        employment_status: "Employment Status*",
        loan_type: "Loan Type*",
        bank: "Select Bank*"
      }
    },
    mr: {
      heading: "कर्जासाठी अर्ज करा",
      submit: "अर्ज सबमिट करा",
      placeholders: {
        first_name: "पहिले नाव*",
        last_name: "आडनाव*",
        email: "ईमेल*",
        phone: "मोबाईल नंबर*",
        pincode: "पिन कोड*",
        income: "मासिक उत्पन्न (₹)*",
        loan_amount: "आवश्यक कर्जाची रक्कम (₹)*",
        questions: "अतिरिक्त प्रश्न (ऐच्छिक)"
      },
      selectOptions: {
        employment_status: "रोजगार स्थिती*",
        loan_type: "कर्जाचा प्रकार*",
        bank: "बँक निवडा*"
      }
    }
  };

  const lang = translations[language];

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    pincode: "",
    employment_status: "",
    loan_type: "",
    bank: "",
    income: "",
    loan_amount: "",
    questions: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validate = () => {
    let newErrors = {};
    if (!formData.first_name.trim()) newErrors.first_name = "First name required";
    if (!formData.last_name.trim()) newErrors.last_name = "Last name required";
    if (!formData.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) newErrors.email = "Valid email required";
    if (!formData.phone.match(/^[0-9]{10}$/)) newErrors.phone = "10-digit mobile number required";
    if (!formData.pincode.match(/^[0-9]{6}$/)) newErrors.pincode = "Valid PIN code required";
    if (!formData.employment_status) newErrors.employment_status = "Select employment status";
    if (!formData.loan_type) newErrors.loan_type = "Select loan type";
    if (!formData.bank) newErrors.bank = "Select a bank";
    if (!formData.income || formData.income <= 0) newErrors.income = "Enter valid income";
    if (!formData.loan_amount || formData.loan_amount <= 0) newErrors.loan_amount = "Enter loan amount";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  const formData = new FormData(e.target);

    if (!validate()) {
    return; // Stop submission if validation fails
  }

  try {
    const res = await fetch("https://mortbuzz.in/api/submit.php", {
      method: "POST",
      body: formData,
    });

    const data = await res.text();

    if (data.trim() === "success") {
      alert("Form submitted successfully!");
      e.target.reset();
    } else {
      alert("Failed to send form. Server said: " + data);
    }
  } catch (err) {
    alert("Error submitting form: " + err.message);
  }
};



  return (
    <div className="apply-now-container">
      <div className="text-end mb-3">
        <button onClick={() => setLanguage(language === "en" ? "mr" : "en")} className="language-toggle">
          {language === "en" ? "मराठीत वाचा" : "Read in English"}
        </button>
      </div>

      <h2 className="form-heading">{lang.heading}</h2>

      <form className="neon-form" onSubmit={handleSubmit}>
        <div className="row g-3">
          {["first_name", "last_name", "email", "phone", "pincode"].map((field, idx) => (
            <div className="col-md-6" key={idx}>
              <input
                className="form-control neon-input"
                type={field === "email" ? "email" : field === "phone" || field === "pincode" ? "tel" : "text"}
                name={field}
                value={formData[field]}
                onChange={handleChange}
                placeholder={lang.placeholders[field]}
              />
              {errors[field] && <div className="error">{errors[field]}</div>}
            </div>
          ))}
        </div>

        <div className="row g-3 mt-3">
          <div className="col-md-4">
            <select
              className="form-select neon-input"
              name="employment_status"
              value={formData.employment_status}
              onChange={handleChange}
            >
              <option value="">{lang.selectOptions.employment_status}</option>
              <option>{language === "en" ? "Salaried" : "नोकरी करणारे"}</option>
              <option>{language === "en" ? "Self-Employed" : "स्वतः व्यवसायिक"}</option>
              <option>{language === "en" ? "Professional" : "व्यवसायिक"}</option>
            </select>
            {errors.employment_status && <div className="error">{errors.employment_status}</div>}
          </div>

          <div className="col-md-4">
            <select
              className="form-select neon-input"
              name="loan_type"
              value={formData.loan_type}
              onChange={handleChange}
            >
              <option value="">{lang.selectOptions.loan_type}</option>
              {[
                "Home Loan",
                "Home Loan Balance Transfer",
                "Loan Against Property",
                "Commercial Loan",
                "Personal Loan",
                "Education Loan",
                "Car Loan"
              ].map((option, idx) => (
                <option key={idx}>{option}</option>
              ))}
            </select>
            {errors.loan_type && <div className="error">{errors.loan_type}</div>}
          </div>

          <div className="col-md-4">
            <select
              className="form-select neon-input"
              name="bank"
              value={formData.bank}
              onChange={handleChange}
            >
              <option value="">{lang.selectOptions.bank}</option>
              {["IDBI Bank", "HDFC Bank", "ICICI Bank", "Bank of Baroda", "State Bank of India", "Bank of Maharashtra", "Bank Of India", "Indian Overseas Bank", "Central Bank Of India", "Kotak Mahindra Bank", "Standard Chartered Bank"].map((bank, idx) => (
                <option key={idx}>{bank}</option>
              ))}
            </select>
            {errors.bank && <div className="error">{errors.bank}</div>}
          </div>
        </div>

        <div className="row g-3 mt-3">
          <div className="col-md-6">
            <input
              className="form-control neon-input"
              type="number"
              name="income"
              value={formData.income}
              onChange={handleChange}
              placeholder={lang.placeholders.income}
            />
            {errors.income && <div className="error">{errors.income}</div>}
          </div>

          <div className="col-md-6">
            <input
              className="form-control neon-input"
              type="number"
              name="loan_amount"
              value={formData.loan_amount}
              onChange={handleChange}
              placeholder={lang.placeholders.loan_amount}
            />
            {errors.loan_amount && <div className="error">{errors.loan_amount}</div>}
          </div>
        </div>

        <div className="mt-3">
          <textarea
            className="form-control neon-input"
            rows="4"
            name="questions"
            value={formData.questions}
            onChange={handleChange}
            placeholder={lang.placeholders.questions}
          />
        </div>

        <div className="text-center mt-4">
          <button type="submit" className="neon-button">
            {lang.submit}
          </button>
        </div>
      </form>
    </div>


  





  );
};

export default ANF;
